import { useEffect } from "react"
import { StarIcon } from "../../../ui/icons/star"
import { SelectCustom } from "../../../ui/molecules/select"
import { AccordionFilter } from "../../../ui/organisms/accordionFilter"
import { FindAllContactsFilters } from "../dto"

interface Props {
    updateFilters: (filter: Partial<FindAllContactsFilters>) => void
    filters: FindAllContactsFilters
    clearAll: boolean
}

export function FavoriteFilter(props: Props) {
    const { updateFilters, filters, clearAll } = props

    const options = [
        { value: 'true', label: 'Sì' },
        { value: 'false', label: 'No' }
    ]

    useEffect(() => {
        if (clearAll) {
            updateFilters({ favorite: undefined })
        }
    }, [clearAll]);

    return (
        <AccordionFilter
            key={'person-filter-favorite'}
            label={"Preferiti"}
            icon={<StarIcon color={""} size={0} active={false} />}
            showClear={filters.favorite !== undefined}
            options={filters.favorite !== undefined ? [filters.favorite ? { value: 'true', label: 'Sì' } : { value: 'false', label: 'No' }] : []}
            clearAction={function (): void {
                updateFilters({ favorite: undefined })
            }}
            deleteFilter={function (option): void {
                updateFilters({ favorite: undefined })
            }}
        >
            <SelectCustom
                isSearchable={false}
                isClearable
                onChange={e => {
                    if (e === undefined) {
                        updateFilters({ favorite: undefined })
                    } else if (typeof e === 'string') {
                        updateFilters({ favorite: { value: e, label: options.find(opt => opt.value === e)?.label! } })
                    }
                }}
                defaultValue={filters.favorite?.value}
                placeholder={"Preferiti"}
                options={options}
            />
        </AccordionFilter>
    )
}